import { useMutation, useQueryClient } from '@tanstack/react-query';

import { llmServiceFetcher } from '../../llm-service/LlmServiceFetcher';

export const useReplayPostSessionWorkflow = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({
            sessionId,
        }: {
            sessionId: string;
        }): Promise<void> => {
            await llmServiceFetcher({
                endpoint: '/transcript-archived/replay',
                method: 'POST',
                body: JSON.stringify({ sessionId }),
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ['workflowRuns'] });
        },
    });
};
